import { useQuery } from "@tanstack/react-query";

import type { PublicEchoFeedbackRecord } from "@/server/echoFeedback";
import { feedbackApiRequest } from "./echoFeedbackClient";

type FeedbackListResponse = {
  data: PublicEchoFeedbackRecord[];
  configured: boolean;
  storageMode?: string;
  total?: number;
  corruptCount?: number;
  legacyCount?: number;
  truncated?: boolean;
};

export function useEchoFeedbackReports(echoId?: string | null) {
  return useQuery({
    queryKey: ["echo-feedback", echoId ?? "all"],
    queryFn: () => {
      const search = new URLSearchParams({ limit: "500" });
      if (echoId) search.set("echoId", echoId);
      return feedbackApiRequest<FeedbackListResponse>(
        `/api/echo-feedback?${search}`,
      );
    },
    enabled: echoId !== null,
    staleTime: 15_000,
  });
}
